import SubjectList from "../views/SubjectList";
import DeviceList from "../views/DeviceList";
import DeviceSessions from "../views/DeviceSessions";
import Notifications from "../views/Notifications";
import NonCompliant from "../views/NonCompliant";
import NonStimulation from "../views/NonStimulation";
import Stimulation from "../views/Stimulation";
import Impadance from "../views/Impadance";
import ChargingFrequency from "../views/ChargingFrequency";

var routes = [

  {
    path: "/device-list",
    name: "Dashboard",
    icon: "ni ni-tv-2 ",
    component: DeviceList,
    layout: "",
  },
  {
    path: "/notifications",
    name: "Notifications",
    icon: "ni ni-bell-55 ",
    component: Notifications,
    layout: "",
  },
  {
    path: "/subject-list",
    name: "Subject List",
    icon: "ni ni-single-copy-04 ",
    component: SubjectList,
    layout: "",
  },
  {
    path: "/report/non-compliant",
    name: "Non-Compliant",
    icon: "ni ni-single-copy-04 ",
    component: NonCompliant,
    layout: "",
  },
  {
    path: "/report/off-stimulation",
    name: "Off-Stimulation",
    icon: "ni ni-single-copy-04 ",
    component: NonStimulation,
    layout: "",
  },
  {
    path: "/report/stimulation",
    name: "Stimulation Usage Summary",
    icon: "ni ni-single-copy-04 ",
    component: Stimulation,
    layout: "",
  },
  {
    path: "/report/impedance",
    name: "Impedance Summary",
    icon: "ni ni-single-copy-04 ",
    component: Impadance,
    layout: "",
  },
  {
    path: "/report/charging-frequency",
    name: "Battery Voltage Trend",
    icon: "ni ni-single-copy-04 ",
    component: ChargingFrequency,
    layout: "",
  },
  {
  path: "/device/:id/p:page",
  component: DeviceSessions,
  layout: "",
},

  {
    path: "/device/:id",
    // name: "Details",
    // icon: "ni ni-tv-2 text-primary",
    component: DeviceSessions,
    layout: "",
  },
  { path: '/', pathTo: '/device-list', redirect: true },
];
export default routes;
